<template>
  <div class="advert-modal" @click="close" id="wrapper-modal">
    <v-container class="px-10">
      <v-card>
        <v-container>
          <AdvertDetails />
        </v-container>
      </v-card>
    </v-container>
    <v-btn x-large icon color="white" class="close-btn" :to="{name: 'search'}">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AdvertDetails from "./AdvertDetails";
export default {
  components: { AdvertDetails },
  data() {
    return {
      mounted: false
    };
  },
  methods: {
    close(e) {
      if (this.mounted && e.target.id == "wrapper-modal") {
        this.$router.push({ name: "search" });
      }

      // this.$router.push({ name: "search" });
    }
  },
  mounted() {
    setTimeout(() => (this.mounted = true), 0);
  }
};
</script>

<style lang="scss" scoped>
.advert-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
  overflow-y: auto;
  scrollbar-color: #4dbc15 rgba(0, 0, 0, 0.3);
  scrollbar-width: thin;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>